import axios from "axios";
import { jwtDecode } from "jwt-decode";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const isValidJWT = (token) => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return false;
    }

    const [header, payload, signature] = parts;
    if (!header || !payload || !signature) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        if (!isValidJWT(token)) {
          throw new Error("Invalid token format.");
        }
        const decodedToken = jwtDecode(token);
        // console.log("Decodedtoken: ", decodedToken);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp < currentTime) {
          console.warn("Token has expired.");
          localStorage.clear();
          window.location.href = "/";
          throw new axios.Cancel("Token has expired");
        } else {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error("Error decoding token: ", error);
        localStorage.clear();
        localStorage.setItem(
          "sessionExpiredMessage",
          "Your session has expired. Please login again."
        );

        window.location.href = "/";
        throw new axios.Cancel("Error decoding token");
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
